import { jsxs as u, jsx as l } from "react/jsx-runtime";
import { forwardRef as h, useMemo as _ } from "react";
import { useMultiStyleConfig as g, chakra as t } from "@chakra-ui/react";
const C = h(
  ({
    __css: s,
    fontWeight: a = "bold",
    icon: n,
    isInitials: e = !1,
    label: o,
    maxWidth: c = "200px",
    size: i = "md",
    variant: m = "primary",
    ...d
  }, f) => {
    const r = g("BadgeTheme", { size: i, variant: m }), p = _(() => e ? { ...r.container, ...r.isInitialContainer } : n ? { ...r.container, ...r.containerWithIcon } : r.container, [r, e]);
    return /* @__PURE__ */ u(t.div, { ref: f, __css: { ...p, ...s }, maxWidth: c, ...d, children: [
      !e && n,
      /* @__PURE__ */ l(t.span, { __css: r.label, fontWeight: a === "bold" ? "medium" : "normal", children: e ? o.toUpperCase().substring(0, 1) : o })
    ] });
  }
);
export {
  C as Badge
};
//# sourceMappingURL=Badge.es.js.map
